<table class="styled-table">
  <thead>
    <tr>
      <th *ngFor="let column of columns">{{ column.label }}</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td *ngFor="let column of columns">
        <div class="card flex justify-center">
          <input
            type="text"
            placeholder="{{ column.label }}"
            pInputText
            [(ngModel)]="newRow[column.name]"
          />
        </div>
      </td>
      <td>
        <p-button
          (click)="addRow()"
          aria-label="Add Row"
          class="w-full"
          variant="text"
        >
          <fa-icon [icon]="faPlus"></fa-icon>
        </p-button>
      </td>
    </tr>
    <tr *ngFor="let row of internalRows; let i = index">
      <td *ngFor="let column of columns">
        {{ row[column.name] }}
      </td>
      <td>
        <p-button
          (click)="delete(i)"
          aria-label="Delete Row"
          class="w-full"
          variant="text"
        >
          <fa-icon [icon]="faTrash"></fa-icon>
        </p-button>
      </td>
    </tr>
  </tbody>
</table>
